module.exports = __webpack_public_path__ + "img/Weapon_153.9718ee50.png";